export const formatNumber = (value) => {
  return new Intl.NumberFormat("es-HN", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(parseFloat(value));
};
